import { skipToken, useResource, useResourceActions } from 'pulse/react';
import { GetThreadAttachmentsRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/AttachmentsRpc.resources';
import { getIsPreview } from '../utils/isPreview';
import { getPreviewThreadAttachments } from './previewMocks';
export const getThreadAttachmentsParams = (ticketId, threadId) => ({
  params: {
    ticketId,
    threadId
  }
});
export const useThreadAttachments = (ticketId, threadId) => {
  const {
    isPreview
  } = getIsPreview();
  const params = getThreadAttachmentsParams(ticketId, threadId);
  const {
    data,
    loading,
    error
  } = useResource(GetThreadAttachmentsRpc, {
    params: isPreview || !ticketId || threadId === undefined ? skipToken : params
  });
  const {
    invalidate
  } = useResourceActions(GetThreadAttachmentsRpc, {
    params
  });
  if (isPreview) {
    return {
      data: getPreviewThreadAttachments(),
      loading: false,
      refetch: invalidate,
      error
    };
  }
  return {
    data,
    loading: loading && !data,
    refetch: invalidate,
    error
  };
};